import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/visits`;
let last = { path: "", at: 0 };

// Random id that changes every day, so a person counts once a day and can't be followed across days.
const visitorId = () => {
  const day = new Date().toLocaleDateString("en-CA", { timeZone: "Australia/Sydney" });
  try {
    const saved = JSON.parse(localStorage.getItem("cj_vid") || "null");
    if (saved?.day === day) return saved.id;
    const id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem("cj_vid", JSON.stringify({ id, day }));
    return id;
  } catch { return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`; }
};

// Where this browser tab first arrived from (kept for the whole visit).
const entrySource = () => {
  try {
    const saved = sessionStorage.getItem("cj_src");
    if (saved) return JSON.parse(saved);
    const own = document.referrer && new URL(document.referrer).host === window.location.host;
    const src = { ref: own ? "" : document.referrer, utm: new URLSearchParams(window.location.search).get("utm_source") || "" };
    sessionStorage.setItem("cj_src", JSON.stringify(src));
    return src;
  } catch { return { ref: "", utm: "" }; }
};

const isPhone = () => window.matchMedia("(pointer: coarse)").matches || /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const send = (path) => {
  if (last.path === path && Date.now() - last.at < 5000) return;
  last = { path, at: Date.now() };
  const { ref, utm } = entrySource();
  const body = JSON.stringify({ path, vid: visitorId(), ref: ref.slice(0, 500), utm: utm.slice(0, 60), device: isPhone() ? "phone" : "computer" });
  fetch(API, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
};

// Count a visit to a public page; signed-in people are never counted.
export const useTrackVisit = (path) => {
  const { user, loading } = useAuth();
  useEffect(() => { if (!loading && !user) send(path); }, [path, loading, user]);
};
